import { useState, useRef } from 'react';
import { Zap, Calendar, Crown } from 'lucide-react';
import AddAutoBillServicesNew from './AddAutoBillServicesNew';
import PageHeader from '../../PageHeader/PageHeader';

function AutoBillingPage({ editMode = null }) {
    const currentDate = new Date().toISOString().split('T')[0];
    const [frequency, setFrequency] = useState('monthly');
    const [selectedMembership, setSelectedMembership] = useState(null);
    const [services, setServices] = useState([]);
    const [purchaseAmount, setPurchaseAmount] = useState(0);
    const addServicesRef = useRef(null);

    const handleServicesUpdate = (updatedServices) => {
        setServices(updatedServices);
    };

    const handlePurchaseAmountUpdate = (amount) => {
        setPurchaseAmount(amount);
    };

    return (
        <div className="min-h-screen bg-gray-50/50 p-0 md:p-6 pb-24 md:pb-6 ">
            <div className="mb-6">
                <PageHeader
                    title={editMode ? "Edit Staff Bill" : "Staff Billing Management"}
                    description={editMode ? "Update bill details and services" : "Create recurring billing schedules with ease"}
                />
            </div>
            <div className="w-full">
                <div className="bg-white md:p-5 rounded-2xl md:border border-purple-100 transition-all duration-300">
                    <AddAutoBillServicesNew
                        ref={addServicesRef}
                        frequency={frequency}
                        currentDate={currentDate}
                        selectedMembership={selectedMembership}
                        editMode={editMode}
                        onServicesUpdate={handleServicesUpdate}
                        onPurchaseAmountUpdate={handlePurchaseAmountUpdate}
                    />
                </div>
            </div>
        </div>
    );
}

export default AutoBillingPage;
